import { types, getEnv, flow, SnapshotOut } from 'mobx-state-tree';
import { observable } from 'mobx';
import { ProgressStateModel, IGroupedApiCtx, errorIsCancel, ProgressStateModelForStore, CalendarEvents, ICalendarEvents, protoUtils } from 'eTip--common';
import { ISportsBettingLiveApi } from '../../api/live/api';
import { CalendarEventStore } from './../calendarEvent';

enum CalendarEventFlags {
    None = 0,
    HasActivePrematch = 1
}

export const SearchStore = types
    .model({
        state: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized),
        searchText: types.optional(types.string, ''),
        events: types.optional(types.array(CalendarEventStore), []),
        textChanged: types.optional(types.boolean, false)
    })
    .actions(self => {

        let env = getEnv(self);
        let synchroCtx: IGroupedApiCtx<ISportsBettingLiveApi> | null = null;

        const setSearchText = (text: string): void => {
            self.searchText = text;
            self.textChanged = true;
        }

        const loadAsync: () => Promise<void> = flow(function* () {
            let ctx: IGroupedApiCtx<ISportsBettingLiveApi> | null = null;
            try {
                if (synchroCtx && synchroCtx.isOpen()) {
                    synchroCtx.cancel('Load has been canceled.');
                    synchroCtx = null;
                }

                self.state = ProgressStateModel.Loading;

                ctx = env.api.open();
                synchroCtx = ctx;

                let searchText = self.searchText;
                if (searchText) {
                    searchText = searchText.trim();
                }

                const response: CalendarEvents = yield ctx.api.getLiveSearchAsync(searchText);

                if (response) {
                    setData(response);

                }

                self.state = ProgressStateModel.Success;
            } catch (error) {
                if (errorIsCancel(error)) {
                    throw error;
                }
                env.loggingService.error(error);
                self.state = ProgressStateModel.Failed;
                throw error;
            } finally {
                if (ctx === synchroCtx) {
                    synchroCtx = null;
                }
                self.textChanged = false;
            }
        });

        const setData = (apiData: ICalendarEvents): void => {
            let result = observable([]);

            if (apiData.Events) {
                apiData.Events.forEach(item => {
                    let store = CalendarEventStore.create(<SnapshotOut<typeof CalendarEventStore>>{
                        id: item.Id,
                        name: item.Name,
                        graphicsPresentationId: item.GraphicsPresentationId,
                        categoryPathName: item.Path,
                        isLive: item.IsLive,
                        time: protoUtils.protoTimeStamp2Date(item.Date).getTime(),
                        sportName: item.SportName,
                        sportCategoryId: item.SportCategoryId,
                        hasActivePrematch: (item.Flags & CalendarEventFlags.HasActivePrematch) === CalendarEventFlags.HasActivePrematch
                    });
                    result.push(store);
                })
            }

            self.events = result;
        }

        return {
            loadAsync,
            setSearchText
        }
    })